/*
 * 增加联系人
 * *
 * */
import { collectionServiceClient } from "@/api/collectionServiceClient";
import { SaveContactReq } from "@/pbjs/xcommon/collection_pb";
import InnerRequest from "./request";
// CommonIn CommonIn = 1;
// //订单ID
// int64 OrderID =2 [jstype = JS_STRING];
// //联系人手机号
// string Contact =3;
// //关系
// int64 Relationship=4;
// //联系人名字
// string Name=5;
// //操作员工ID
// int64 OpUID =6;
export interface Options {
    OrderID?: string;
    Contact?: string;
    Relationship?: number;
    Name?: string;
    OpUID?: number;
    Extcontactid?: number;
}
export function setSaveContactReq(arg: Options) {
    let request: any = new SaveContactReq();
    request.setOrderid(arg.OrderID);
    request.setContact(arg.Contact);
    request.setRelationship(arg.Relationship);
    request.setName(arg.Name);
    request.setOpuid(arg.OpUID);
    request.setExtcontactid(arg.Extcontactid);
    return request;
}
export const saveContactReqRequest = new InnerRequest(
    collectionServiceClient,
    collectionServiceClient.saveContact
);
